import React from "react";
import { Page } from "components/ui/Page";
import { Layout } from "components/ui/Layout";
import DelegateLandingCard from "components/cards/DelegateLandingCard";

export default function DelegateLandingPage() {
  return (
    <Page>
      <Layout>
        <DelegateLandingCard />
      </Layout>
    </Page>
  );
}
